import {
  IntegrationsSchema,
  addressTypeSchema,
} from "@redotech/redo-return-core-common/address-collection";
import * as z from "zod";

export const getOrCreateExternalAddress = {
  name: "getOrCreateExternalAddress" as const,
  input: z.object({
    provider: addressTypeSchema,
    externalId: z.string(),
    integrations: IntegrationsSchema.optional(),
  }),
  output: z.object({ addressId: z.string() }),
};
